export default __webpack_public_path__ + "static/media/ic_notifications_none_48px.5a4ba1fa.svg";